import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { ProductListCard } from '../components/ProductsListCard';
import { ProductSubtypeListCard } from './components/ProductSubtypeListCard';
import { ProductTypeDeleteCard } from './components/ProductTypeDeleteCard';
import { ProductTypeDetailsCard } from './components/ProductTypeDetailsCard';

export function ProductTypeDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const productTypeQueryResults = useQuery({
        queryKey: ['productType', id],
        queryFn: () => Api.Products.Types.getProductType(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs} title="Details">
            <QueryRenderer results={productTypeQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <ProductTypeDetailsCard productType={data} />
                            <ProductSubtypeListCard
                                productType={data}
                                refetch={productTypeQueryResults.refetch}
                            />
                            <ProductListCard
                                products={data.products}
                                refetch={productTypeQueryResults.refetch}
                            />

                            {!data.subtypes.length && (
                                <Can I="delete" a="Alcohol">
                                    <ProductTypeDeleteCard productType={data} />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
